var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-boxes-container",class:_vm.extraClasses},_vm._l((_vm.products),function(item){return _c('product-box',{key:item.id,attrs:{"data":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }